import PlanosGoverno from '@/views/admin/plano-governo'
import PlanosGovernoDetails from '@/views/admin/plano-governo/Details'
import PlanoGovernoEdit from '@/views/admin/plano-governo/Edit'
import PlanoGovernoSave from '@/views/admin/plano-governo/Save'
import CompromissoImportar from  '@/views/admin/plano-governo/compromisso/Importar'
import CompromissoEditar from  '@/views/admin/plano-governo/compromisso/EditarResponsaveis'
import MeusCompromisso from  '@/views/admin/plano-governo/compromisso/MeusCompromissos'
import CompromissoAcaoSave from '@/views/admin/plano-governo/acao/Save'
import CompromissoAcaoEdit from '@/views/admin/plano-governo/acao/Edit'
import MinhasAcoes from '@/views/admin/plano-governo/acao/MinhasAcoes'

export const planoGoverno = [
  {
    name: 'admin_planogoverno',
    path: 'planogoverno/',
    component: PlanosGoverno,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_details',
    path: 'planogoverno/details/:id',
    component: PlanosGovernoDetails,
    props: true,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_edit',
    path: 'planogoverno/edit/:id',
    component: PlanoGovernoEdit,
    props: true,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_save',
    path: 'planogoverno/save/',
    component: PlanoGovernoSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_compromisso_import',
    path: 'planogoverno/compromisso/importar',
    component: CompromissoImportar,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_compromisso_editar',
    path: 'planogoverno/compromisso/editar',
    component: CompromissoEditar,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_meus_compromissos',
    path: 'planogoverno/compromisso',
    component: MeusCompromisso,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_acao_save',
    path: 'planogoverno/compromisso/acao/save/:id',
    props: true,
    component: CompromissoAcaoSave, 
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_acao_edit',
    path: 'planogoverno/compromisso/acao/edit/:id',
    props: true,
    component: CompromissoAcaoEdit,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_planogoverno_minhas_acoes',
    path: 'planogoverno/acao',
    component: MinhasAcoes,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/admin/planoGoverno.js